import { render } from "./OurFeatures.vue?vue&type=template&id=7f404ade"
import script from "./OurFeatures.vue?vue&type=script&lang=js"
export * from "./OurFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__